<template>
  <div class="blindprize_page">
    <div class="receive">
      <img
        v-if="receive == 0"
        class="receive_btn"
        src="../assets/img/blindreceive.png"
        @click="receiveFun"
      />
      <img
        v-else-if="receive == 1"
        class="receive_btn"
        src="../assets/img/blindreceived.png"
      />
      <img v-else class="receive_btn" src="../assets/img/blindNotreceive.png" />
    </div>
    <div class="Champion_box">
      <span class="Champion">
        <img v-if="cf" src="../assets/img/obtained.png" class="state" />
        <span v-else>
          <img src="../assets/img/noObtained.png" class="state" />
          <img src="../assets/img/lock.png" class="lock" />
        </span>
      </span>
      <span class="Champion">
        <img v-if="js" src="../assets/img/obtained.png" class="state" />
        <span v-else>
          <img src="../assets/img/noObtained.png" class="state" />
          <img src="../assets/img/lock.png" class="lock" />
        </span>
      </span>
      <span class="Champion">
        <img v-if="hn" src="../assets/img/obtained.png" class="state" />
        <span v-else>
          <img src="../assets/img/noObtained.png" class="state" />
          <img src="../assets/img/lock.png" class="lock" />
        </span>
      </span>
      <span class="Champion">
        <img v-if="ms" src="../assets/img/obtained.png" class="state" />
        <span v-else>
          <img src="../assets/img/noObtained.png" class="state" />
          <img src="../assets/img/lock.png" class="lock" />
        </span>
      </span>
      <span class="Champion">
        <img v-if="blqs" src="../assets/img/obtained.png" class="state" />
        <span v-else>
          <img src="../assets/img/noObtained.png" class="state" />
          <img src="../assets/img/lock.png" class="lock" />
        </span>
      </span>
    </div>

    <van-popup style="background: none" v-model="popupshow">
      <div :class="result ? 'prizeTips success' : 'prizeTips error'">
        <span v-if="result">{{ integral }}</span>
        <img src="../assets/img/define.png" @click="popupshow = false" />
      </div>
      <img
        src="../assets/img/close_btn.png"
        class="close"
        @click="popupshow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { openService } from "@/utils/common";

import {
  pageBuryingPoint,
  eventBuryingPoint,
  DestructyBuryingPoint,
} from "@/utils/BuryingPoint";
import fetch from "@/utils/fetch";

import { showToast, pageRecord, setHtmlTitle } from "@/utils/h5";
export default {
  name: "blindprize",
  data() {
    return {
      subCode: "lcj_lottery",
      popupshow: false, //领取结果弹窗展示
      result: null, //领取结果状态成功/失败
      cf: 0,
      js: 0,
      hn: 0,
      ms: 0,
      blqs: 0,
      receive: null, //领取按钮状态。
      integral: "",
    };
  },
  created() {
    setHtmlTitle("领取奖励");
    pageBuryingPoint("p_ytwx818lcjlqjls_01");
    var that = this;
    fetch.post("/lcj/surTimes", { subCode: that.subCode }).then((res) => {
      if (res.code == 10000) {
        let data = res.data;
        that.cf = data.cmhzt.cfxzy;
        that.js = data.cmhzt.jsxzy;
        that.hn = data.cmhzt.hnxzy;
        that.ms = data.cmhzt.msxzy;
        that.blqs = data.cmhzt.blqsxzy;
        that.receive = data.lqzt;
        if (that.cf == 0 || that.js == 0 || that.ms == 0 || that.blqs == 0) {
          that.receive = 2;
        }
      } else {
        showToast({ message: res.msg, duration: 2000 });
      }
    });
  },
  beforeDestroy() {
    //页面销毁前
    DestructyBuryingPoint("p_ytwx818lcjlqjls_01");
  },
  methods: {
    receiveFun() {
      var that = this;
      eventBuryingPoint("c_ytwxyx_01", "p_ytwx818lcjlqjlsdetails_01");
      fetch
        .post("/lcj/drawLotteryAll", { subCode: that.subCode })
        .then((res) => {
          if (res.code == 10000) {
            that.popupshow = true;
            that.result = true;
            that.integral = res.msg;
            that.receive = 1;
          } else if (res.code == 10114) {
            that.popupshow = true;
            that.result = false;
            that.receive = 1;
          } else if (res.code == 10028) {
            showToast({
              message: "您的排名在10名以外，奖品已领完",
              duration: 2000,
            });
          } else if (res.code == 10009) {
            showToast({
              message: "您的排名在10名以外，奖品已领完",
              duration: 2000,
            });
          }  else {
            showToast({ message: res.msg, duration: 2000 });
          }
        });
    },
  },
};
</script>

<style scoped>
</style>
